module.exports = __webpack_public_path__ + "assets/img/cricket-next.cf206845.jpg";